import { getBarConfig } from '../../bar/getBarConfig'
import type { RackOptions } from '../../../RackTypes'
import { RACK_COLORS } from '../../../constants'
import { findBundleProduct, getAccessoryQuantity } from '../../../utils/product-lookup'
import { getCustomMaterials } from '../../../utils/material-utils'
import { getDepthSelection, getPlateStorageSelection, getHeightSelection, getHardwareSelection, getFrontSelection, getMiddleSelection, getBackSelection, getSafetySelection, getJCupSelection, getFrontStabilizerSelection, getBandPegSelection, getBackStabilizerSelection, getBenchSelection, getPlateSelection } from '../../../utils/selection-utils'
import { PowerRackBuilder } from './powerRackBuilder'
import { IRogue, BuyRequest } from '@/js/services/RogueTypes'
import { getBuyRequestMeta, getSimpleForBuyRequest } from '@/js/helpers/buy-request'

// Config for RM 3, 4, 6, RML 390, 490, 690, RML-3
export function createPowerRackConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const meta = getBuyRequestMeta(buyRequest, rogue)
  const rack = getSimpleForBuyRequest(buyRequest, rogue)
  const bar = findBundleProduct(rogue, buyRequest, 'Add a bar', true)

  const isRML = meta.name.includes('RML')
  const is390C = meta.name.includes('RML-390')
  const isRML3 = meta.name.includes('R-3')

  const line = isRML ? 'RML' : 'RM'
  const numbered = rack.attributes.edition === 'Numbered' || rack.attributes.upright_type === 'Numbered' || line === 'RM'
  const storage = !!meta.groupSku?.includes('RM-6') || !!meta.name?.includes('690')
  const color = RACK_COLORS[rack.attributes.rig_color as string || 'Satin Black']

  const spotterArmsAccessory = getAccessoryQuantity(rogue, buyRequest, 'spotter arms')
  const strapSafetyAccessory = Boolean(getAccessoryQuantity(rogue, buyRequest, 'strap safety'))
  const multiGripAccessory = Boolean(getAccessoryQuantity(rogue, buyRequest, 'Multi Grip'))

  // Get nameplate, safeties, and txt gray uprights, crown, and top xmember materials
  const materials = getCustomMaterials(rogue, buyRequest) 

  return {
    line,
    depth           : getDepthSelection(rack, meta),
    numbered,
    sixPost         : storage,
    plateStorage    : getPlateStorageSelection(rogue, buyRequest),
    color,
    height          : getHeightSelection(rack),
    hardware        : getHardwareSelection(rogue, buyRequest),
    front           : getFrontSelection(rogue, buyRequest, meta),
    middle          : isRML3 || is390C ? getMiddleSelection(multiGripAccessory) : undefined,
    back            : getBackSelection(rogue, buyRequest, meta),
    safeties        : getSafetySelection(rogue, buyRequest, meta, strapSafetyAccessory),
    jcup            : isRML3 ? getJCupSelection(rogue, buyRequest, true) : getJCupSelection(rogue, buyRequest),
    frontStabilizer : getFrontStabilizerSelection(rogue, buyRequest, meta),
    spotterArms     : spotterArmsAccessory,
    bandPegs        : getBandPegSelection(rogue, buyRequest),
    backStabilizer  : getBackStabilizerSelection(rogue, buyRequest, meta),
    bench           : getBenchSelection(rogue, buyRequest),
    bar             : bar ? getBarConfig(rogue, bar) : undefined,
    plates          : getPlateSelection(rogue, buyRequest),
    accessories     : [],
    materials,
    isRML3,
  }
}

export function createRack(rogue: IRogue, buyRequest: BuyRequest) {
  const config: RackOptions = createPowerRackConfig(rogue, buyRequest)
  const part = new PowerRackBuilder(config).build() // No factory needed for this product
  
  return { config, part }
}